import useOpportunityReportType from "../Shared/useOpportunityReportType"
import OpportunityCard from "./OpportunityCard"

export default ({ 
  shipModals 
}) => {
  const { reportTypes } = useOpportunityReportType()

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', padding: '0px' }}>
      {reportTypes.map(r => {
        return (
          <OpportunityCard key={r.id} title={r.title} reportType={r.id} shipModals={shipModals} />
        )
      })}
    </div>
  )
}